import { Injectable } from '@angular/core';
import { EmployeeDto } from '@shared/service-proxies/service-proxies';

@Injectable()
export class ConsultantDisplayNameExtractService {
    constructor() {}

    getDisplayName(consultant: EmployeeDto): string {
        return consultant
            ? consultant.name && consultant.surname && consultant.title
                ? `${consultant.title} ${consultant.name} ${consultant.surname}`
                : consultant.importedName
            : null;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/consultant-display-name-extract.service.ts